// extracted by mini-css-extract-plugin
export default {"routine":"routineWindow_routine__V1vG8"};